module.exports = __webpack_public_path__ + "static/kartchen1-55050c3acfa4447600862e9f1f4964ad.png";